import inventory from './inventory.js'
import inventoryValuation from './inventoryValuation.js'
import turnover from './turnover.js'
import receipts from './receipts.js'
import deficit from './deficit.js'
import conversion from './conversion.js'
import transfer from './transfer.js'
import warehouses from './warehouses.js'

export default {
  menu: 'Warehousing',
  title: 'Warehousing',

  warehouses,

  inventory,

  inventoryValuation,

  turnover,

  receipts,

  deficit,

  conversion,

  transfer
}
